// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"46164898","769":"973f6189"}[chunkId] + ".chunk.js";
};